import * as R from 'remeda';

import * as timeUtility from './time';

function iterator<T extends Record<string, any>>(args: {
  list: T[] | null;
  transformer(item: T): void;
}) {
  const { list, transformer } = args;

  if (!R.isDefined(list)) return;

  const length = list.length;

  for (let index = 0; index < length; index++) {
    const item = list[index];
    if (!R.isDefined(item)) continue;
    transformer(item);
  }
}

function toDateResolution(dates: Time.Date[]) {
  const dateResolutions = dates.map((date) => {
    const year = date.year;
    let monthNumber: number | undefined = undefined;
    let weekNumber: number | undefined = undefined;
    let dayOfMonth: number | undefined = undefined;

    switch (date.type) {
      case 'year':
        break;
      case 'month':
        monthNumber = date.month + 1;
        break;
      case 'week':
        weekNumber = date.week;
        break;
      case 'day':
        monthNumber = date.month + 1;
        dayOfMonth = date.dayOfMonth;
        break;
    }
    const dateResolution: API.DateResolution = {
      year,
      monthNumber,
      weekNumber,
      dayOfMonth,
    };

    return dateResolution;
  });
  return dateResolutions;
}

function extractDateId(args: {
  year: number;
  monthNumber: number | null;
  dayOfMonth: number | null;
  weekNumber: number | null;
}) {
  let { monthNumber } = args;
  const { dayOfMonth, year, weekNumber } = args;
  let dateId = '';
  if (R.isDefined(monthNumber)) monthNumber = monthNumber - 1;
  // Day
  if (
    R.isDefined(monthNumber) &&
    R.isDefined(dayOfMonth)
    // && R.isDefined(weekNumber) should contain weeknumber
  ) {
    dateId = timeUtility.generateDayId(year, monthNumber, dayOfMonth);
  }
  // Week
  else if (
    !R.isDefined(monthNumber) &&
    R.isDefined(weekNumber) &&
    !R.isDefined(dayOfMonth)
  )
    dateId = timeUtility.generateWeekId(year, weekNumber);
  // Month
  else if (
    R.isDefined(monthNumber) &&
    !R.isDefined(weekNumber) &&
    !R.isDefined(dayOfMonth)
  )
    dateId = timeUtility.generateMonthId(year, monthNumber);
  // Year
  else if (
    !R.isDefined(monthNumber) &&
    !R.isDefined(weekNumber) &&
    !R.isDefined(dayOfMonth)
  )
    dateId = timeUtility.generateYearId(year);

  return dateId;
}

export { extractDateId, iterator, toDateResolution };
